function c(t, r) {
  const e = this;
  return e.vars && typeof e.getColorSchemeSelector == "function" ? {
    [e.getColorSchemeSelector(t).replace(/(\[[^\]]+\])/, "*:where($1)")]: r
  } : e.palette.mode === t ? r : {};
}
export {
  c as default
};
